/**
 * Javascript file with utility functions.
 * @author Adrian Rebmann, Michael Frey
 */

export { setCookie, getCookie };

/**
 * Sets the cookie and its values.
 * @param {*} cname - The cookie's name.
 * @param {*} cvalue - The cookie's value.
 * @param {*} exdays - The expiration days.
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Gets the cookie.
 * @param {*} cname - The cookies name
 * @returns {string}
 */
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/util.js